<template>
	<div class="root">
		<img src="../assets/head.gif" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				timer: '',
				banner: null,
				footer: null
			};
		},
		methods: {
			goToMainPage() {
				this.$router.push("/home")
			}
		},
		mounted() {
			this.banner = document.getElementById("nav");
			this.footer = document.getElementsByClassName("footer")[0];
			this.banner.style.display = 'none';
			this.footer.style.display = 'none';
			this.timer = setInterval(this.goToMainPage, 3550);
		},
		beforeDestroy() {
			this.banner.style.display = 'block';
			this.footer.style.display = 'block';
			clearInterval(this.timer);
		}
	};
</script>

<style scoped>
	.root {
		position: fixed;
		z-index: 2000;
		margin-top: -50px;
	}

	img {
		width: 100vw;
		height: 100vh;
	}
</style>
